import { Box } from "@chakra-ui/react";
import { NavBar } from "@components/ui-kit";
import { Trans } from "@lingui/macro";
import { useGetSubmittedRfiCountQuery } from "@src/__generated__/graphql";
import { can } from "@src/utils/components/permissions";
import { useStore } from "@src/utils/hooks";
import { observer } from "mobx-react-lite";
import { useRouter } from "next/router";
import { AppSubNav } from "../AppSubNav";

const NavigationFinance = () => {
  const { workspaceStore } = useStore();
  const { pathname } = useRouter();

  const { data } = useGetSubmittedRfiCountQuery({
    fetchPolicy: "cache-and-network",
  });

  return (
    <Box
      fontSize={{
        base: "xs",
        "2xl": "sm",
      }}
    >
      <AppSubNav>
        <NavBar.Item
          href={{ pathname: "/invoices/for-invoicing" }}
          badgeColorScheme="green"
          badgeContent={data?.getSubmittedRfiCount}
          sidePadding="1"
        >
          <Trans>Request for invoicing</Trans>
        </NavBar.Item>
        {workspaceStore.settings?.moduleSettings.billing_plan && (
          <NavBar.Item
            href={{ pathname: "/invoices/invoicing-plan" }}
            active={pathname.startsWith("/invoices/invoicing-plan")}
            sidePadding="1"
          >
            <Trans>Invoicing plan</Trans>
          </NavBar.Item>
        )}
        <NavBar.Item
          href={{ pathname: "/invoices/credit-accounts" }}
          active={
            pathname === "/invoices/credit-accounts" ||
            pathname === "/credit-accounts/global"
          }
          sidePadding="1"
        >
          <Trans>Credit accounts</Trans>
        </NavBar.Item>
        <NavBar.Item
          href={{ pathname: "/invoices/proforma-invoices" }}
          sidePadding="1"
        >
          <Trans>Proforma invoices</Trans>
        </NavBar.Item>
        <NavBar.Item
          href={{ pathname: "/invoices/outgoing-invoices" }}
          sidePadding="1"
        >
          <Trans>Outgoing invoices</Trans>
        </NavBar.Item>
        <NavBar.Item href={{ pathname: "/expenses" }} sidePadding="1">
          <Trans>Expenses</Trans>
        </NavBar.Item>
        {can(["wip_read_all", "wip_read_team", "wip_read_own"]) && (
          <NavBar.Item href={{ pathname: "/work-in-progress" }} sidePadding="1">
            <Trans>Work progress</Trans>
          </NavBar.Item>
        )}
        {workspaceStore.settings?.enableBank && can("bank_read_all") && (
          <NavBar.Item href={{ pathname: "/bank" }} sidePadding="1">
            <Trans>Bank</Trans>
          </NavBar.Item>
        )}
      </AppSubNav>
    </Box>
  );
};

export default observer(NavigationFinance);
